export default "__VITE_ASSET__XqZ5PQ59__"